<div class="boards-list" cdkDropListGroup>
  <iu-kanban-board-ui
    *ngFor="let kanbanGroup of kanbanGroups"
    [tabId]="tabId"
    [tableName]="tableName"
    [container]="this.container"
    [kanbanGroup]="kanbanGroup"
    [isFlexDesign]="kanbanGroups.length === 1"
    [columnsDisplayAD]="this.columnsDisplayAD"
    [kanbanImageColumn]="this.kanbanImageColumn"
    [(draggedElement)]="draggedElement"
    (changeGroupEmitter)="queryDataStore()"
    (clickEmitter)="clickEmitter.emit($event)"></iu-kanban-board-ui>
</div>
